import Vue from 'vue'

import VueRouter from "vue-router";

/** HOME */
import Home from '@/components/Home.vue'

/** Offline */
import Offline from '@/components/Offline.vue'

/* Status */
import Status from '@/components/Status.vue'

/* Ajuda */
import Ajuda from '@/components/Ajuda.vue'

/* Review */
import Review from '@/components/Review.vue'

/* About */
import About from '@/components/About.vue'

/* Biometria */
import Biometria from '@/components/Biometria.vue'

/* Privacy */
import Privacy from '@/components/Privacy.vue'

/* Privacy */
import Tutorial from '@/components/Tutorial.vue'

/* Contato */
import Contato from '@/components/Contato.vue'

/* Info */
import Info from '@/components/Info.vue'

/* Legal */
import Legal from '@/components/Legal.vue'

/* Termos */
import Termos from '@/components/Termos.vue'

/* Sobre */
import Sobre from '@/components/Sobre.vue'

/* TutorialCnis */
import TutorialCnis from '@/components/TutorialCnis.vue'

let mapped_routes = [
  {
    path: '/Censo/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/Status/',
    name: 'Status',
    component: Status,
  },
  {
    path: '/Biometria/',
    name: 'Biometria',
    component: Biometria,
  },
  {
    path: '/Ajuda/',
    name: 'Ajuda',
    component: Ajuda,
  },
  {
    path: '/TutorialCnis/',
    name: 'TutorialCnis',
    component: TutorialCnis,
  },
  {
    path: '/Tutorial/:step?',
    name: 'Tutorial',
    component: Tutorial,
  },
  {
    path: '/Contato/:action?',
    name: 'Contato',
    component: Contato,
  },
  {
    path: '/Review/',
    name: 'Review',
    component: Review,
  },
  {
    path: '/Offline/',
    name: 'Offline',
    component: Offline,
  },
  {
    path: '/About/',
    name: 'About',
    component: About,
    alias: '/'
  },
  {
    path: '/Info/',
    name: 'Info',
    component: Info,
  },
  {
    path: '/Legal/',
    name: 'Legal',
    component: Legal,
  },
  {
    path: '/Termos/',
    name: 'Termos',
    component: Termos,
  },
  {
    path: '/Sobre/',
    name: 'Sobre',
    component: Sobre,
  },
  {
    path: '/Privacy/',
    name: 'Privacy',
    component: Privacy,
  },
  {
    path: '*',
    redirect: '/'
  }
]

Vue.use(VueRouter);

export default new VueRouter({
  base: '/',
  mode: 'history',
  routes: mapped_routes,
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js